module.exports = __webpack_public_path__ + "static/img/6.fe41041.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/sp/6.png
// module id = sOnb
// module chunks = 0